import type { StylePropertiesTypes } from '@wix/document-services-types'
import { getConverterString } from '../../utils/converterHelpers'
import type { BuilderFitContentFunction, BuilderAnchorSizeFunction } from '@wix/thunderbolt-becky-root'

/** Internal Converters */
const fitContentFunctionConverter = (prop: BuilderFitContentFunction): string => {
	const valueConverter = getConverterString(prop.value.type, prop.value)
	return `fit-content(${valueConverter})`
}

const anchorSizeFunctionConverter = (prop: BuilderAnchorSizeFunction): string => {
	return `anchor-size(${prop.axis})`
}

const dimensionFunctionConverter = (prop: StylePropertiesTypes.Height | StylePropertiesTypes.Width): string => {
	if (prop.type !== 'Function') {
		return ''
	}

	if (prop.function === 'fit-content') {
		return fitContentFunctionConverter(prop as BuilderFitContentFunction)
	}
	if (prop.function === 'anchor-size') {
		return anchorSizeFunctionConverter(prop as BuilderAnchorSizeFunction)
	}
	return ''
}

/** External Map - Only provide converters for new functionality */
export const dimensionConverterMap = {
	// Only provide Function converter for dimension-specific functions
	// Length, Percentage, and Keyword are already handled by existing atomic converters
	Function: dimensionFunctionConverter,
} as Record<string, (prop: StylePropertiesTypes.Height | StylePropertiesTypes.Width) => string>
